import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, stopSubmit } from "redux-form";
import { Form, FormGroup, Label, Alert } from "reactstrap";

import TextInput from "../../../system/fields/TextInput";
import SelectDropdown from "../../../system/fields/SelectDropdown";
import FileUpload from "../../../system/fields/FileUpload";
import StarRating from "../../../system/fields/StarRating";

import * as validations from "../../../system/utils/Validation";
import DatePickerOld from "../../../system/fields/DatePickerOld";
import { getAirports, getEnquiryStatuses } from "../../../store/overview";

class EditForm extends React.Component {
  componentDidMount() {
    this.props.dispatch(getAirports());
    this.props.dispatch(getEnquiryStatuses());
  }

  render() {
    const { props } = this;
    const { handleSubmit, mode, fields } = props;
    return (
      <section className="edit-form">
        <Form onSubmit={handleSubmit}>
          <section className="form-section">
            <div className={"row"}>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Status</Label>
                <Field
                  name={"enquiry_status"}
                  component={SelectDropdown}
                  options={props.enquiryStatuses}
                  labelKey={"name"}
                  valueKey={"id"}
                />
              </FormGroup>
            </div>
            <div className={"row"}>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>First Name</Label>
                <Field
                  name={"first_name"}
                  component={TextInput}
                  type={"text"}
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Last Name</Label>
                <Field
                  name={"last_name"}
                  component={TextInput}
                  type={"text"}
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Deal Name</Label>
                <Field
                  name={"deal_name"}
                  component={TextInput}
                  type={"text"}
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Departure Date</Label>
                <Field
                  name={"departure_date"}
                  component={DatePickerOld}
                  dateFormat={"MMM dd yyyy h:mm a"}
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Travellers</Label>
                <Field
                  name={"number_of_people"}
                  component={TextInput}
                  type={"number"}
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Phone Number</Label>
                <Field
                  name={"phone_number"}
                  component={TextInput}
                  type={"phone"}
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Email</Label>
                <Field
                  name={"email"}
                  component={TextInput}
                  type={"email"}
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Airport</Label>
                <Field
                  name={"departure_airport"}
                  component={SelectDropdown}
                  options={props.airports}
                  type={"text"}
                  labelKey={"name"}
                  valueKey={"id"}
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-12">
                <Label>Comments</Label>
                <Field name="comment" component="textarea" disabled />
              </FormGroup>
              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="email">Total Price</Label>
                <Field
                  name="total_price"
                  component={TextInput}
                  type="text"
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="email">Referrer</Label>
                <Field name="ref" component={TextInput} type="text" disabled />
              </FormGroup>
              <FormGroup className="col-12 col-sm-6">
                <Label htmlFor="email">GCLID</Label>
                <Field
                  name="gclid"
                  component={TextInput}
                  type="text"
                  disabled
                />
              </FormGroup>
              <FormGroup className={"col-12 col-sm-6"}>
                <Label>Callback Time</Label>
                <Field
                  name={"callback_date"}
                  component={DatePickerOld}
                  dateFormat={"MMM dd yyyy h:mm a"}
                  disabled
                />
              </FormGroup>
            </div>
          </section>
        </Form>

        {props.submitFailed && (
          <div className="error-container">
            <Alert color="danger">
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: "TestForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("TestForm"));
    }
  },
})(EditForm);

const mapStateToProps = (state) => ({
  airports: state.overview.airports,
  enquiryStatuses: state.overview.enquiryStatuses,
});

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Enquiries/DealEnquiry/Form.jsx